// extracted by mini-css-extract-plugin
module.exports = {"container":"Amount-module__container___-e_cl","button":"Amount-module__button___1MP-n","input":"Amount-module__input___3AfaP"};